<app-seamless-header></app-seamless-header>

<section class="extra_padding_for_header">
<div class="progress-bar-custom">
    <div class="progress-bar-custom__fill"></div>
</div>

<div [ngClass]="setPosition ? 'position-fix' : (!moved ? 'center' : 'moved')"
    class="box d-flex flex-column align-items-center justify-content-center">
    <div class="d-flex flex-column welcome-text text-center">
        <div>
            <div>{{userName}}, you could SAVE</div>
            <div>R {{(monthlyInstalment - dbc_Dcrs) | number :'1.0-0'}} every month</div>
        </div>
        <div class="align-self-center blue_line"></div>
        <div class="snapshot">Consolidate your debt and <div class="credit_health">unlock cash for daily living</div>
        </div>
    </div>


    <section class="full-screen-section" *ngIf="displayDbQuoteSection">

    <div>
        <div class="logo-holder">
        <img src="../../assets/images/dblogonew.png" alt="DebtBusters Logo" width="72px" />
        <img src="../../assets/images/logoJM.png" alt="JustMoney Logo" width="120px" />
        </div>

         <div class="db-popup-section">
         <div class="dbpopup-body-container">
          <div class="d-flex mb-2 mb-md-3">
            <div class="flex-grow-1 text-start">
              <p class="m-0 text-blk dbpopup-fs ">Current total monthly debt payment </p>
            </div>
            <div class="text-end text-md-start">
              <p class="m-0 text-blk dbpopup-fs text-nowrap pad-3"><span>R {{monthlyInstalment | number :'1.0-0'}}</span>
            </p>
            </div>
          </div>
          <div class="d-flex ">
            <div class="flex-grow-1">
              <p class="m-0 text-blk dbpopup-fs text-start">Estimated new single monthly payment </p>
            </div>
            <div class="text-end text-md-start">
              <p class="m-0 text-blk dbpopup-fs text-nowrap pad-3"><span >R {{dbc_Dcrs | number:'1.0-0'}}</span>
            </p>
            </div>
          </div>
          <hr class="mt-2 mb-2">
          <div class="d-flex mb-2">
            <div class="flex-grow-1">
              <p class="m-0 text-blk dbpopup-fs2 text-start text-wrap">Estimated monthly saving </p>
            </div>
            <div class="dbpopup-mw">
              <p class="m-0 dbpopup-fs2 text-blk text-nowrap pad-3">
                <span>R {{(monthlyInstalment - dbc_Dcrs) | number :'1.0-0'}}</span>
            </p>
            </div>
          </div>
          <div class="checklist">
            <div class="dbpopup-item">
              <img src="../../assets/images/check-icon-dark.svg">
              <span class="dbpopup-item-text">Make one, lower monthly payment</span>
            </div>
            <div class="dbpopup-item">
              <img src="../../assets/images/check-icon-dark.svg">

              <span class="dbpopup-item-text">Pay less interest</span>
            </div>
            <div class="dbpopup-item">
              <img src="../../assets/images/check-icon-dark.svg">
              <span class="dbpopup-item-text">Free up more cash for living expenses</span>
            </div>
            <div class="dbpopup-item mb-0">
              <img src="../../assets/images/check-icon-dark.svg">

              <span class="dbpopup-item-text">Get legal protection from creditors</span>
            </div>
          </div>
        </div>

        <hr class="mt-3 mb-3">

        <p class="ofxt text-center foot-text">Offer subject to change after further assessment by the solution provider, DebtBusters. By clicking “Apply Now” you agree to the DebtBusters&#39; <a name="btn_TermsCondition_Dashboard"
          class="footerlinkclr" href="/terms" target="_blank" routerLink="/terms">Terms and Conditions</a>. </p>

          <div class="d-flex justify-content-center primary-btn-container">
            <button type="submit" (click)="DBLeadInsert('btn_leadGen_consolidateLoan_callBack_registration')"
              class="primary-btn m-0 w-100" id="btn_leadGen_consolidateLoan_callBack_registration" name="btn_leadGen_consolidateLoan_callBack_registration">Apply now</button>
          </div>

          <div class="d-flex justify-content-center secondary-btn-container">
            <button  type="button" (click)="SkipCallback()"
              class="m-0 w-100 secondary-btn" id="btn_userJourney_goToDashboard_registration" name="btn_userJourney_goToDashboard_registration">Maybe later</button>
          </div>

        </div>


    </div>

</section>
</div>

<ng-template #callbackStatusModel let-modal>
  <div class="modal-header">
    <h4 *ngIf="callbackErrorMsg==''" class="modal-title fw-bold">Call-back incoming...</h4>
        <h4 *ngIf="callbackErrorMsg!=''" class="modal-title fw-bold">Free callback request</h4>
    <button type="button" class="close" id="btn_auxiliaryButton_consolidateLoan_callBackRequested_popUp_close" name="btn_auxiliaryButton_consolidateLoan_callBackRequested_popUp_close" isCloseButton="true"
      data-dismiss="modal" aria-label="Close" (click)="closePopup()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="callbackErrorMsg ==''" class="modal-body" class="success-box" >
    
 
    <img  src="../../assets/images/dblogonew.png" alt="DebtBusters Logo" width="72px" />
    <p class="mt-2 mb-0">Stand by, a DebtBusters expert will call you soon.</p>
  </div>
  <div *ngIf="callbackErrorMsg!=''" class="modal-body" >
   <div  class="alert alert-danger" role="alert">
      {{callbackErrorMsg}}
      </div>
    </div>
  <div class="modal-footer dc-success-footer" *ngIf="callbackErrorMsg==''">
    <button type="button" class="primary-success-btn" id="btn_auxiliaryButton_consolidateLoan_callBackRequested_popUp_close2" name="btn_auxiliaryButton_consolidateLoan_callBackRequested_popUp_close2" (click)="closePopup()">OK, thanks!</button>
  </div>
</ng-template>
</section>
